"use strict";

var _regeneratorRuntime = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _slicedToArray = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var cov_dsn9858v4 = function () {
  var path = "/Volumes/GithubWorkspace/gitea-react-toolkit/src/components/repository/crud/RepositoryQuickCreate.js";
  var hash = "6046d067d50d8ff7edfaad4f7dc4f16b37f4bfb1";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/Volumes/GithubWorkspace/gitea-react-toolkit/src/components/repository/crud/RepositoryQuickCreate.js",
    statementMap: {
      "0": {
        start: {
          line: 30,
          column: 26
        },
        end: {
          line: 30,
          column: 36
        }
      },
      "1": {
        start: {
          line: 32,
          column: 27
        },
        end: {
          line: 39,
          column: 3
        }
      },
      "2": {
        start: {
          line: 33,
          column: 4
        },
        end: {
          line: 37,
          column: 5
        }
      },
      "3": {
        start: {
          line: 34,
          column: 6
        },
        end: {
          line: 36,
          column: 9
        }
      },
      "4": {
        start: {
          line: 38,
          column: 4
        },
        end: {
          line: 38,
          column: 24
        }
      },
      "5": {
        start: {
          line: 41,
          column: 23
        },
        end: {
          line: 44,
          column: 3
        }
      },
      "6": {
        start: {
          line: 42,
          column: 23
        },
        end: {
          line: 42,
          column: 61
        }
      },
      "7": {
        start: {
          line: 43,
          column: 4
        },
        end: {
          line: 43,
          column: 33
        }
      },
      "8": {
        start: {
          line: 46,
          column: 2
        },
        end: {
          line: 85,
          column: 4
        }
      },
      "9": {
        start: {
          line: 72,
          column: 34
        },
        end: {
          line: 72,
          column: 61
        }
      },
      "10": {
        start: {
          line: 88,
          column: 0
        },
        end: {
          line: 103,
          column: 2
        }
      },
      "11": {
        start: {
          line: 105,
          column: 15
        },
        end: {
          line: 126,
          column: 2
        }
      },
      "12": {
        start: {
          line: 105,
          column: 27
        },
        end: {
          line: 126,
          column: 1
        }
      },
      "13": {
        start: {
          line: 128,
          column: 37
        },
        end: {
          line: 128,
          column: 87
        }
      }
    },
    fnMap: {
      "0": {
        name: "RepositoryQuickCreateComponent",
        decl: {
          start: {
            line: 18,
            column: 9
          },
          end: {
            line: 18,
            column: 39
          }
        },
        loc: {
          start: {
            line: 29,
            column: 3
          },
          end: {
            line: 86,
            column: 1
          }
        },
        line: 29
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 32,
            column: 27
          },
          end: {
            line: 32,
            column: 28
          }
        },
        loc: {
          start: {
            line: 32,
            column: 38
          },
          end: {
            line: 39,
            column: 3
          }
        },
        line: 32
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 41,
            column: 23
          },
          end: {
            line: 41,
            column: 24
          }
        },
        loc: {
          start: {
            line: 41,
            column: 35
          },
          end: {
            line: 44,
            column: 3
          }
        },
        line: 41
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 72,
            column: 22
          },
          end: {
            line: 72,
            column: 23
          }
        },
        loc: {
          start: {
            line: 72,
            column: 33
          },
          end: {
            line: 72,
            column: 62
          }
        },
        line: 72
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 105,
            column: 15
          },
          end: {
            line: 105,
            column: 16
          }
        },
        loc: {
          start: {
            line: 105,
            column: 27
          },
          end: {
            line: 126,
            column: 1
          }
        },
        line: 105
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 33,
            column: 4
          },
          end: {
            line: 37,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 33,
            column: 4
          },
          end: {
            line: 37,
            column: 5
          }
        }, {
          start: {
            line: 33,
            column: 4
          },
          end: {
            line: 37,
            column: 5
          }
        }],
        line: 33
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "6046d067d50d8ff7edfaad4f7dc4f16b37f4bfb1"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RepositoryQuickCreate = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

var _icons = require("@material-ui/icons");

var _helpers = require("../helpers");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function RepositoryQuickCreateComponent(_ref) {
  var classes = _ref.classes,
      authentication = _ref.authentication,
      _ref$authentication = _ref.authentication,
      _ref$authentication$u = _ref$authentication.user,
      username = _ref$authentication$u.username,
      avatar_url = _ref$authentication$u.avatar_url,
      config = _ref$authentication.config,
      onRepository = _ref.onRepository;
  cov_dsn9858v4.f[0]++;

  var _ref2 = (cov_dsn9858v4.s[0]++, (0, _react.useState)()),
      _ref3 = _slicedToArray(_ref2, 2),
      repo = _ref3[0],
      setRepo = _ref3[1];

  cov_dsn9858v4.s[1]++;

  var updateRepository = function updateRepository(_repo) {
    cov_dsn9858v4.f[1]++;
    cov_dsn9858v4.s[2]++;

    if (_repo) {
      cov_dsn9858v4.b[0][0]++;
      cov_dsn9858v4.s[3]++;
      _repo = (0, _helpers.extendRepository)({
        repository: _repo,
        authentication: authentication,
        updateRepository: updateRepository,
        config: config
      });
    } else {
      cov_dsn9858v4.b[0][1]++;
    }

    cov_dsn9858v4.s[4]++;
    onRepository(_repo);
  };

  cov_dsn9858v4.s[5]++;

  var handleCreate = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var repository;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              cov_dsn9858v4.f[2]++;
              cov_dsn9858v4.s[6]++;
              _context.next = 4;
              return (0, _helpers.createRepository)({
                repo: repo,
                config: config
              });

            case 4:
              repository = _context.sent;
              cov_dsn9858v4.s[7]++;
              updateRepository(repository);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleCreate() {
      return _ref4.apply(this, arguments);
    };
  }();

  cov_dsn9858v4.s[8]++;
  return _react.default.createElement(_core.ListItem, {
    alignItems: "flex-start",
    ContainerComponent: "div",
    className: classes.root
  }, _react.default.createElement(_core.ListItemAvatar, {
    className: classes.listItemAvatar
  }, _react.default.createElement(_core.Avatar, {
    alt: username,
    src: avatar_url,
    className: classes.avatar
  })), _react.default.createElement("form", {
    className: classes.form
  }, _react.default.createElement("div", {
    className: classes.input
  }, _react.default.createElement(_core.TextField, {
    id: "owner",
    label: "Owner",
    type: "text",
    disabled: true,
    variant: "outlined",
    margin: "normal",
    fullWidth: true,
    defaultValue: username
  })), _react.default.createElement("div", {
    className: classes.input
  }, _react.default.createElement(_core.TextField, {
    id: "repo",
    label: "Repository",
    type: "text",
    required: true,
    variant: "outlined",
    margin: "normal",
    fullWidth: true,
    defaultValue: "",
    autoFocus: true,
    autoComplete: undefined,
    onChange: function onChange(event) {
      cov_dsn9858v4.f[3]++;
      cov_dsn9858v4.s[9]++;
      setRepo(event.target.value);
    }
  }))), _react.default.createElement(_core.ListItemSecondaryAction, null, _react.default.createElement(_core.IconButton, {
    "aria-label": "Add Repo",
    onClick: handleCreate
  }, _react.default.createElement(_icons.AddCircle, null))));
}

cov_dsn9858v4.s[10]++;
RepositoryQuickCreateComponent.propTypes = {
  classes: _propTypes.default.object.isRequired,

  /** Function to call when repository is selected. */
  onRepository: _propTypes.default.func.isRequired,

  /** A passed authentication object from login. */
  authentication: _propTypes.default.shape({
    user: _propTypes.default.object.isRequired,
    token: _propTypes.default.object.isRequired,
    config: _propTypes.default.shape({
      /** The Gitea server to use when authenticating. */
      server: _propTypes.default.string.isRequired,

      /** The id of the token to create/retrieve that is used for the app. */
      tokenid: _propTypes.default.string.isRequired
    }).isRequired
  })
};
cov_dsn9858v4.s[11]++;

var styles = function styles(theme) {
  cov_dsn9858v4.f[4]++;
  cov_dsn9858v4.s[12]++;
  return {
    listItemAvatar: {
      marginRight: '16px',
      marginTop: '20px'
    },
    avatar: {
      borderRadius: '20%'
    },
    root: {
      borderRadius: theme.shape.borderRadius,
      marginLeft: 0,
      width: '100%'
    },
    form: {
      width: '100%'
    },
    input: {
      width: '40%',
      display: 'inline-block',
      marginRight: '1em'
    }
  };
};

var RepositoryQuickCreate = (cov_dsn9858v4.s[13]++, (0, _styles.withStyles)(styles)(RepositoryQuickCreateComponent));
exports.RepositoryQuickCreate = RepositoryQuickCreate;